import { Injectable } from '@angular/core';
import { AuthConfiguration, LoginInfo } from '@barthauer/abc/core/authentication';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { ArrayMap, UserViewModel } from '../models/view.model';

// loadindicator
// vor/zurück änderung messageboxen
// auf ABC controls umstellen

@Injectable()
export class ContextService {
  readonly users = new ArrayMap<string, UserViewModel>('id');

  resAsync?: Promise<void>;
  res: ResourceSet = ResourceSet.Empty;
  authConfiguration: AuthConfiguration;
  loginInfo: LoginInfo;

  get allowWindowsAuth(): boolean {
    if (typeof this.authConfiguration?.allowIntegratedSecurity === 'boolean') {
      return this.authConfiguration.allowIntegratedSecurity;
    }

    return (
      (this.authConfiguration?.useLocalSecurityContext ?? false) ||
      (this.authConfiguration?.useRemoteSecurityContext ?? false)
    );
  }

  get isAdmin(): boolean {
    return this.loginInfo?.isAdmin ?? false;
  }

  get currentUserId(): string {
    let id = this.loginInfo?.userId;

    if (!id) {
      const name = this.loginInfo?.userName?.toLowerCase();

      if (name) {
        for (const user of this.users.array) {
          if (user.login.toLowerCase() === name) {
            id = user.id;
            break;
          }
        }
      }
    }

    return id ?? '';
  }

  constructor(resourceManagerService: ResourceManagerService) {
    this.resAsync = resourceManagerService.getResourceSet('abc-management-users').then((resourceSet) => {
      this.res = resourceSet;
      this.resAsync = undefined;
    });
  }

  setResource(action: (res: ResourceSet) => void): void {
    const resAsync = this.resAsync;

    if (resAsync) {
      resAsync.then(() => action(this.res));
    } else {
      action(this.res);
    }
  }
}

export enum StringLiteral {}
